'use client';

import { FactionLeaderboardProps } from './faction-leaderboard.type';
import { Mobile } from '../../../../../packages/ui/components/responsive';
import {
  FactionLeaderboardDesktop,
  FactionLeaderboardMobile,
  FactionRowHeaderDesktop,
} from './faction-leaderboard-responsive';
import { FC } from 'react';
import { LeaderboardSkeleton } from './leaderboard-skeleton';

export const FactionLeaderboardSkeleton: FC<
  Pick<
    FactionLeaderboardProps,
    'desktopHeader' | 'mobileHeader' | 'desktopRowHeader' | 'containerClassname'
  > & {
    nRows?: number;
  }
> = ({
  desktopHeader,
  mobileHeader,
  nRows = 10,
  desktopRowHeader,
  containerClassname,
}) => {
  return (
    <LeaderboardSkeleton
      desktopHeader={desktopHeader}
      mobileHeader={mobileHeader}
      nRows={nRows}
      desktopRowHeader={desktopRowHeader || <FactionRowHeaderDesktop />}
      containerClassname={containerClassname}
    />
  );
};

export const FactionLeaderboard = ({
  data,
  mobileHeader,
  desktopHeader,
  desktopRowHeader,
  containerClassname,
  customColumnNames,
}: FactionLeaderboardProps) => {
  return (
    <Mobile
      fallback={
        <FactionLeaderboardDesktop
          containerClassname={containerClassname}
          data={data}
          desktopHeader={desktopHeader}
          desktopRowHeader={desktopRowHeader}
        />
      }
      loading={
        <FactionLeaderboardSkeleton
          desktopHeader={desktopHeader}
          mobileHeader={mobileHeader}
          containerClassname={containerClassname}
        />
      }
    >
      <FactionLeaderboardMobile
        data={data}
        mobileHeader={mobileHeader}
        customColumnNames={customColumnNames}
      />
    </Mobile>
  );
};
